// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAttributes_container__1_3Xq","sending":"JobAttributes_sending__1WXgN"};